import {Transaction} from '../../types/interfaces/transaction';

export class FetchTransactions {
  static readonly type = '[Transactions] Fetch All';

  constructor(public payload: Transaction[]) {
  }
}
